import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

export const FavoriteItem = ({ eventId }) => {
    const [favorite_events, setFavoriteEvents] = useState(
        Cookies.get("favorite_events") ? JSON.parse(Cookies.get("favorite_events")) : []
    );
    const isFavorite = favorite_events.includes(eventId);
    const event = new Event("favorite-updated");

    const toggleFavorite = () => {
        //console.log("toggleFavorite:" + eventId );
        let newFavoriteEvents = favorite_events;
        if(isFavorite){
            newFavoriteEvents = favorite_events.filter(id => id !== eventId);
        } else {
            newFavoriteEvents = [...favorite_events, eventId];
        }
        setFavoriteEvents(newFavoriteEvents);
        Cookies.set("favorite_events", JSON.stringify(newFavoriteEvents), { expires: 300 });
        document.dispatchEvent(event);
    };

    useEffect(() => {
        //console.log(favorite_events);
        document.querySelectorAll(`.programm-item`).forEach((element) => {
            element.classList.remove("filter-type-favorited");
        });
        favorite_events.forEach((eventId) => {
            const element = document.querySelector(
                `.programm-item[data-evid="${eventId}"]`
            );
            //console.log(`.programm-item[data-evid="${eventId}"]`);
            if (element) {
                element.classList.add("filter-type-favorited");
            }
        });
    }, [favorite_events]);

    useEffect(() => {
        document.addEventListener('favorite-updated', function(){
            //console.log("event received");
            setFavoriteEvents(JSON.parse(Cookies.get("favorite_events")));
        });
        return () => {
            document.removeEventListener('favorite-updated', function(){
                //console.log("event removed");
            });
        };
    }, []);

    return (
        <div className="favorite-item" onClick={toggleFavorite}>
            <div className="favorite-item-icon">
                {isFavorite ? <div className="favorite-item-icon-selected"></div> : <div className="favorite-item-icon-unselected"></div>}
            </div>
        </div>
    );
};
